import { CustomSmartSearchConfig } from '@/core/types'

export const DEFAULT_AUTOCOMPLETE_AGGREGATION_FIELDS = Object.freeze(['brand', 'categories'] as const)

export interface ResolvedCustomSmartSearchConfig {
  accordionSearchEnabled: boolean
  accordionVisibleItemsLimit: number
  accordionMode: boolean
  accordionClearFiltersButtonEnabled: boolean
  autocompleteAggregationFields: string[]
}

const DEFAULT_CUSTOM_SMART_SEARCH_CONFIG: ResolvedCustomSmartSearchConfig = {
  accordionSearchEnabled: true,
  accordionVisibleItemsLimit: 0,
  accordionMode: true,
  accordionClearFiltersButtonEnabled: true,
  autocompleteAggregationFields: []
}

function normalizeVisibleItemsLimit(value: unknown): number {
  const numericValue = typeof value === 'number' ? value : Number(value)

  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return 0
  }

  return Math.floor(numericValue)
}

function normalizeAutocompleteAggregationFields(value: unknown): string[] {
  if (value === null || value === undefined) {
    return []
  }

  if (!Array.isArray(value)) {
    return []
  }

  const sanitized = value
    .map((entry) => typeof entry === 'string' ? entry.trim() : '')
    .filter((entry) => entry.length > 0)

  if (sanitized.length === 0) {
    return []
  }

  return Array.from(new Set(sanitized))
}

export function resolveCustomSmartSearchConfig(): ResolvedCustomSmartSearchConfig {
  if (typeof window === 'undefined') {
    return { ...DEFAULT_CUSTOM_SMART_SEARCH_CONFIG }
  }

  const rawConfig = window?._QONizer?.customSmartSearchConfig as CustomSmartSearchConfig | undefined

  if (!rawConfig) {
    return { ...DEFAULT_CUSTOM_SMART_SEARCH_CONFIG }
  }

  return {
    accordionSearchEnabled: rawConfig.accordionSearchEnabled ?? DEFAULT_CUSTOM_SMART_SEARCH_CONFIG.accordionSearchEnabled,
    accordionVisibleItemsLimit: normalizeVisibleItemsLimit(rawConfig.accordionVisibleItemsLimit),
    accordionMode: rawConfig.accordionMode ?? DEFAULT_CUSTOM_SMART_SEARCH_CONFIG.accordionMode,
    accordionClearFiltersButtonEnabled: rawConfig.accordionClearFiltersButtonEnabled ?? DEFAULT_CUSTOM_SMART_SEARCH_CONFIG.accordionClearFiltersButtonEnabled,
    autocompleteAggregationFields: normalizeAutocompleteAggregationFields(rawConfig.autocompleteAggregationFields)
  }
}
